import { InsightsStateSelector } from 'app-redux/InsightsState';
import * as dto from 'client/dto';

const bepiValuesByLocationId: (locationId: number) => InsightsStateSelector<Record<dto.BepiCategory, number>> = (locationId: number) => state =>
  state.bepi.bepiValuesByLocationIdAndCategory[locationId];
const getVulnerabilityIndexByLocationId: (locationId: number) => InsightsStateSelector<number> = (locationId: number) => state => {
  const overall = state.bepi.bepiValuesByLocationIdAndCategory[locationId]?.[dto.BepiCategory.BEPIOverall];
  return overall ? Math.round(overall * 100) : null;
};
const getBepiLocationName: (locationId: number) => InsightsStateSelector<string> = (locationId: number) => state =>
  state.bepi.bepiLocationNameByLocationId[locationId];

export default {
  bepiValuesByLocationId,
  getVulnerabilityIndexByLocationId,
  getBepiLocationName,
};
